// extracted by mini-css-extract-plugin
module.exports = {"shareLinks":"style_shareLinks__0XmD0","shareWrap":"style_shareWrap__E4WHG","applyWrapper":"style_applyWrapper__n66SW","webShare":"style_webShare__qH_qI"};